export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this digital or physical?',
    answer:
      'Completely digital. All the content is PDF — there are no videos for now. Instant access, and you can print anything you want.',
  },
  {
    question: 'Do I need to be a jazz specialist to teach with this?',
    answer:
      "No. Most teachers using it come from rock, pop, or classical guitar. Every session tells you what to explain, in what order, and what to listen for, so you can stay one clear step ahead of your student while you learn the material yourself.",
  },
  {
    question: "Will this work for my students' skill level?",
    answer:
      'Yes. The system scales from absolute beginner through advanced. All materials are modular and adaptable.',
  },
  {
    question: 'Can I customize the lessons for my students?',
    answer:
      'Absolutely. Every lesson is editable and designed to be personalized to your specific teaching context.',
  },
  {
    question: 'How do I access the material?',
    answer:
      'Instant PDF download after checkout. Everything arrives in your email within 2 minutes.',
  },
  {
    question: "What if I'm not completely satisfied?",
    answer:
      'Email support within 10 days of your purchase and we refund the full amount. You keep every file you downloaded.',
  },
]
